import React from "react";
import EpisodeInfoPage from "../episodes/EpisodeInfoPage";
import { getPodcastEpisodeInfo } from "../../../store/actions/uploadMediaAction";

const ViewPodcastEpisode = () => (
  <EpisodeInfoPage
    idParam="podcastEpisode_id"
    storeKey="generalContentObjPodcastEpisodeInfo"
    setEpisodeInfo={getPodcastEpisodeInfo}
    pagePath={(id) => `/dashboard/podcast-episode-info/${id}`}
    commentsType="podcast"
    noMediaText="Video has not been uploaded yet!"
  />
);

export default React.memo(ViewPodcastEpisode);
